import makeCrudMetaReducer from 'weego-common/src/utils/makeCrudMetaReducer';
import { actionTypes as vehiclesActionTypes } from '../../actions/vehicles';

export default makeCrudMetaReducer(vehiclesActionTypes);
